import BigNumber from 'bignumber.js';
import type { DepthData, DepthDeltaData } from '@/models/futures';

/** Input is an already normalized snapshot; publish one immutable book per batch. */
export function applyDepthDeltas(book: DepthData, updates: DepthDeltaData[]): DepthData {
  let sequence = new BigNumber(book.u);
  let sequenceId = book.u;
  let asks: DepthData['a'] | undefined;
  let bids: DepthData['b'] | undefined;
  updates.forEach(update => {
    const nextSequence = new BigNumber(update.id);
    if (update.s !== book.s || !nextSequence.gt(sequence)) return;
    sequence = nextSequence;
    const isBid = update.ba === 1;
    const side = isBid ? (bids || book.b) : (asks || book.a);
    const price = new BigNumber(update.p);
    let low = 0;
    let high = side.length;
    while (low < high) {
      const middle = (low + high) >>> 1;
      const comparison = new BigNumber(side[middle][0]).comparedTo(price);
      if (isBid ? comparison > 0 : comparison < 0) low = middle + 1;
      else high = middle;
    }
    const exists = low < side.length && price.eq(side[low][0]);
    const positive = new BigNumber(update.q).gt(0);
    const changed = exists ? !new BigNumber(side[low][1]).eq(update.q) : positive;
    if (changed) {
      const writable = isBid ? (bids || (bids = book.b.slice())) : (asks || (asks = book.a.slice()));
      if (exists) writable.splice(low, 1, ...(positive ? [[update.p, update.q] as [string, string]] : []));
      else writable.splice(low, 0, [update.p, update.q]);
    }
    sequenceId = update.id;
  });
  return sequenceId === book.u ? book : { ...book, u: sequenceId, a: asks || book.a, b: bids || book.b };
}
